<template>
  <div id="app">
    <metainfo>
      <template v-slot:title="{ content }">{{ content }}</template>
    </metainfo>

    <header-view></header-view>
    <main-view></main-view>
    <footer-view></footer-view>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta'
import HeaderView from './views/HeaderView.vue'
import FooterView from './views/FooterView.vue'
import MainView from './views/MainView.vue'

export default {
  name: 'App',
  components: {
    HeaderView,
    FooterView,
    MainView,
  },
  setup () {
    useMeta({
      title: 'ISP Generic incidents',
      htmlAttrs: { lang: 'en', amp: true }
     })
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>
